export default __webpack_public_path__ + "static/forward-edge-ai-logo-6e1d8a50e3070258c683b6feeaf5b642.png";